
namespace Matrix {

    @Serenity.Decorators.registerFormatter('Matrix.TestResultCodeFormatter')
    export class TestResultCodeFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            return TestResultCodeFormatter.formatValue(ctx.value);
        }

        public static formatValue(value: string) {
            if (!value)
                return "";

            var color;
            if (value === "PASS")
                color = "green";
            else if (value == "FAIL")
                color = "red";
            else if (value == "WARN")
                color = "orange";
            else if (value == "IGNORE")
                color = "gray";
            else
                color = "black";

            return `<span class="text-${color}"><i class="fa fa-circle"></i> ${Q.htmlEncode(value)}</span>`;
        }
    }
}